import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const useDeptWiseAssignTo = () => {
    const loginUserData = useSelector((state) => state.loginData.userData)
    const userDataDept = loginUserData?.department.map((itm) => { return itm.label }).toString()
    const userDept = loginUserData?.department.map((itm) => { return itm.label }).toString()
    const activeTabName = useSelector((state) => state.activeData?.activeNumberKey?.activeTab);

    const [assignToOptions, setAssignToOptions] = useState([]);

    useEffect(() => {
        const fetchAssignTo = async () => {
            try {
                const payload = userDataDept !== userDept ?
                    {
                        departmentName: "",
                        subDepartment: "",
                    }
                    :
                    {
                        departments: activeTabName === "Other Department Task" ? ["others"] : "",
                        subDepartment: "",
                        empId: activeTabName === "Other Department Task" ? loginUserData?.empId : "",
                        assignedEmployee: activeTabName === "Other Department Task" ? "" : loginUserData?.assignedEmployee,
                        loginempId: activeTabName === "Other Department Task" ? "" : loginUserData?.empId
                    };

                const res = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/emp/getEmployeeByDepartment`,
                    payload
                );

                const options =
                    res?.data?.data?.map((item) => ({
                        label: `${item.firstName} ${item.lastName}`,
                        value: item.empId,
                        upcomingLeaves: item?.upcomingLeaveDates || [],
                    })) || [];

                setAssignToOptions(options);
            } catch (error) {
                console.log("Assign To Error", error);
            }
        };

        fetchAssignTo();
    }, [loginUserData]);

    return { assignToOptions };
};

export default useDeptWiseAssignTo;